// Copyright (c) 2022 by Move Closer

import { abstractModuleContentResolver } from '../abstract/abstract-resolver'
import { ModuleContentResolver } from '../../contexts'

import { BreadcrumbsModuleContent, BreadcrumbsModuleContentInput } from './Breadcrumbs.contracts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const resolveBreadcrumbsModuleContent: ModuleContentResolver<BreadcrumbsModuleContentInput, BreadcrumbsModuleContent> =
  abstractModuleContentResolver
